import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react'

interface ThemeContextType {
  isDarkMode: boolean
  toggleThemeMode: () => void
  setThemeMode: (mode: 'light' | 'dark') => void
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

interface ThemeProviderProps {
  children: ReactNode
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    // Încarcă preferința din localStorage sau folosește dark mode ca default
    const savedMode = localStorage.getItem('themeMode')
    if (savedMode) {
      return savedMode === 'dark'
    }
    
    // Default la dark mode pentru login page
    return true
  })

  const toggleThemeMode = () => {
    setIsDarkMode(prev => !prev)
  }

  const setThemeMode = (mode: 'light' | 'dark') => {
    setIsDarkMode(mode === 'dark')
  }

  // Salvează preferința în localStorage
  useEffect(() => {
    localStorage.setItem('themeMode', isDarkMode ? 'dark' : 'light')
    
    // Aplică tema la body pentru CSS custom
    document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light')
  }, [isDarkMode])

  // Nu mai ascultăm preferința sistemului - folosim dark mode ca default

  const value: ThemeContextType = {
    isDarkMode,
    toggleThemeMode,
    setThemeMode,
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useThemeMode = (): ThemeContextType => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useThemeMode must be used within a ThemeProvider')
  }
  return context
}
